import { BaseGameState } from "onearm";
import { AutoplayController } from "onearm";
import { GameLogic } from "onearm";

export class SubGameState extends BaseGameState {
    /**
     *
     * @type {GameLogic}
     */
    gameLogic = null;

    /**
     * @type {GameState}
     */
    gameState = null;
    /**
     *
     * @type {Game}
     */
    game = null;
    /**
     *
     * @type {AutoplayController}
     */
    autoplay = null;

    constructor(parameters) {
        super(parameters);

        this.gameLogic = parameters.services.get("gameLogic");
        this.data = parameters.services.get("data");
        this.gameState = parameters.owner;
        this.reels = this.gameState.reels;
        this.autoplay = this.gameState.autoplay;
        this.hud = this.gameState.hud;
        this.api = parameters.services.get("api");
    }
    enter() {
        super.enter();
    }

    exit() {
        this.signals.disconnectAll();
    }

    update(_dt) {}

    spin() {}
}
